import {
  faEnvelope,
  faLocationDot,
  faMobileScreen,
  faPhone
} from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

import Address from '@/components/Address';
import useStartCall from '@/hooks/useStartCall';
import PhoneNumber from '@/pages/Profile/components/ContactInfoSection/components/PhoneNumberSection/PhoneNumber';
import { Card, CopyContent, Typography } from '@/ui';
import usFormatPhoneNumber from '@/utils/usFormatPhoneNumber';

import ContactRow from '../ContactRow';

import type { Props } from './types';

const copyClassName = 'mp-sensitive flex min-w-0 justify-between [&>span:first-child]:truncate';

const PersonContactCard = ({ person }: Props) => {
  const handleCall = useStartCall(person.id);
  const email = person.emails.find((entry) => entry.default);
  const phone = person.phones.find((entry) => entry.default);
  const address = person.addresses.find((entry) => entry.default);

  if (!person.app_login_email && !email && !phone && !address) return null;

  return (
    <Card padding="md" className="flex flex-col gap-3">
      <Typography variant="subheading">Contact</Typography>
      {person.app_login_email && (
        <ContactRow icon={faMobileScreen} label="App login email">
          <CopyContent content={person.app_login_email} className={copyClassName} />
        </ContactRow>
      )}
      {email && (
        <ContactRow icon={faEnvelope} label="Contact email">
          <CopyContent content={email.address} className={copyClassName} />
        </ContactRow>
      )}
      {phone && (
        <ContactRow icon={faPhone} label="Default phone">
          <div className="mp-sensitive flex items-center gap-2">
            <a className="hover:underline" href={`tel:${phone.number}`}>
              {usFormatPhoneNumber(phone.number)}
            </a>
            <PhoneNumber phone={phone} onCall={handleCall} showLink={false} size="sm" />
          </div>
        </ContactRow>
      )}
      {address && (
        <ContactRow icon={faLocationDot} label="Default address">
          <div className="mp-sensitive">
            <Address address={address} />
          </div>
        </ContactRow>
      )}
    </Card>
  );
};

export default memo(PersonContactCard);
